import { ToggleButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CountBadge } from '@omnea-app/omui/CountBadge'
import { SegmentedControl } from '@omnea-app/omui/SegmentedControl'

type ResolveButtonsProps = {
  loading: boolean
  unresolvedMentionsCount: number
  handleResolveChange: (value: boolean) => void
  showResolved: boolean
}

export const ResolveButtons = ({ loading, unresolvedMentionsCount, handleResolveChange, showResolved }: ResolveButtonsProps) => {
  const { t } = useTranslation('dashboard')
  return (
    <SegmentedControl
      value={showResolved ? 'RESOLVED' : 'UNRESOLVED'}
      onChange={(_, value) => handleResolveChange(value === 'RESOLVED')}
    >
      <ToggleButton value="UNRESOLVED">
        {t('mentions.unresolved')}
        {!loading && unresolvedMentionsCount !== 0 && <CountBadge count={unresolvedMentionsCount} color="neutral" />}
      </ToggleButton>
      <ToggleButton value="RESOLVED">{t('mentions.resolved')}</ToggleButton>
    </SegmentedControl>
  )
}
